import { Sidebar, Menu, MenuItem } from 'react-pro-sidebar';
import { AppRoute } from "../../Routes";
import { NavLink } from "react-router-dom";
import { Logo } from "./Logo";
import './sideBar.scss'
import {ContactUs, HomeIcon, SignOutIcon, CollapseIcon, ExpandIcon} from "../icons/Icons";
import { useAuthContext } from "../../AuthContext";
import { useEntitlements } from "../../EntitlementProvider";
import { Permission } from "../../Permission";

export interface SideBarProps {
    routes: AppRoute[]
    collapsed: boolean
    onToggleCollapse: () => void
}

export const SideBar = ({ routes, collapsed, onToggleCollapse }: SideBarProps) => {

    const logout = useAuthContext()?.logout
    const contactUs = useEntitlements()?.has(Permission.CONTACT_US)

    const handleLogoutClick = () => {
        if (logout) {
            logout()
        }
    };

    const links = routes.map((route, index) =>
        <MenuItem icon={(route.icon) ?? <HomeIcon />} className={'sidebar-link'} key={'sideBarLinks' + index} component={<NavLink to={route.path} />} data-testid={'side-bar-link-' + index}>
            {route.readableName}
        </MenuItem>)

    return <Sidebar className={'sidebar'} backgroundColor="#093A1D" collapsed={collapsed}>
        <div className={'sidebar-logo'}>
            <Logo />
        </div>
        <Menu>
            {links}
        </Menu>
        {(contactUs || logout) &&
            <div className={'sidebar-footer'}>
                <Menu>
                    {contactUs &&
                        <MenuItem
                            icon={<ContactUs/>}
                            className={'sidebar-link'}
                            key={'sideBarLinks-contact'}
                            component={<a href="mailto:operations@oaktreepower.com"/>}
                            data-testid={'contact-us-button'}
                        >
                            Contact Us
                        </MenuItem>
                        }
                    {logout &&
                        <MenuItem  onClick={handleLogoutClick} icon={<SignOutIcon/>} className={'sidebar-link'} key={'sideBarLinks-logout'}
                                  component={<NavLink to={''}/>} data-testid={'logout-button'}>
                            logout
                        </MenuItem>
                    }
                </Menu>
            </div>
        }
        <div className={'sidebar-collapse-toggle'}>
            <button
                onClick={onToggleCollapse}
                className={'sidebar-collapse-toggle__button'}
                data-testid={'sidebar-collapse-toggle'}
                aria-label={collapsed ? 'Expand sidebar' : 'Collapse sidebar'}
            >
                {collapsed ? <ExpandIcon /> : <CollapseIcon />}
            </button>
        </div>
    </Sidebar>
}